<template>
  <div id="app">
    <Home></Home>
  </div>
</template>

<style>

</style>

<script>
  import Home from './views/Home'
  export default {
    components: {
      Home
    },
    name: 'app'
  }
</script>